import { render, staticRenderFns } from "./GlobalWidgetConfig.vue?vue&type=template&id=2ae3e4f7"
import script from "./GlobalWidgetConfig.js?vue&type=script&lang=js&external"
export * from "./GlobalWidgetConfig.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports